module.exports = __webpack_public_path__ + "static/media/partner-3.6116db67.webp";